import React from 'react';
import FeatherIconWrapper from '../Icons/FeatherIconWrapper'
import ActivityIcon from '../Icons/Notification/Notification'
import {  White } from '../../Constants/ColorChart'
import "./RecentActivityIcon.css";
import {
  IconContainer
} from '../ResultTable/Components/ResultRow/StyledResultRow';

/*
 *  @Description:   Component that renders the Recent Activity Icon.
 */

export const RecentActivityIcon = ( props ) => {
    const { handleActivity, search } = props;
    return (
        <div className={ search? "ActivityIconWrapper search": "ActivityIconWrapper" }>
            <IconContainer
                className={ "iconContainer iconActivity" }
                data-title={ "Notifications" } >
                <FeatherIconWrapper
                    className={ "ActivityIcon top-bar-icon" }
                    color={ White }
                    onClick={ handleActivity}
                    width="33px"
                    iconStyle="stroke-width: 1.3px; &:hover{cursor: pointer}; margin-top: -2px;"
                    Icon={ ActivityIcon }
                    ariaLabel={ "recent-activity" }
                    role={"button"}
                />
            </IconContainer>
        </div>
    );
}
